import { action, observable } from 'mobx'

class CashierOrderStore {
    @observable
    refresh: boolean = false

    @action
    setRefresh() {
        this.refresh = !this.refresh
    }
}

export const cashierOrderStore = new CashierOrderStore()
